import { connect } from 'react-redux'
import { getUserId } from '@layers-frontend/commons/store/selectors/user'
import { canUseLayi } from '../../selectors/users'
import LayiNotificationsModal from '../../components/ModalComponents/LayiNotificationsModal'

// Gated on ROLE_WEB_LAYI like every part of LAYI: without it the modal closes itself unseen.
const mapStateToProps = state => ({
  userId: getUserId(state),
  canUseLayi: canUseLayi(state)
})

export default connect(mapStateToProps)(LayiNotificationsModal)
